const dashboard_layout = {
    // layout items
    dashboardItemName: String("Panel principal"),
    terrainsItemName: String("Fincas"),
    plotsItemName: String("Parcelas"),
    modulesItemName: String("Estaciones"),
    accountItemName: String("Mi Perfil"),
    graphicsItemName: String("Gráficos"),
    
    // navbar
    userOverlayBoxTitle: String("Bienvenido {name}"),
    profile: String("Mi Perfil"),
    logOut: String("Cerrar sesión"),

    // footer
    footerAboutUs:  String("Sobre nosotros"),
    footerContactUs: String("Contacta con nosotros"),

};

export default dashboard_layout;